module.exports = __webpack_public_path__ + "static/media/Saaya_Final.fa1a3a90.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Saaya_Final.mp4
// module id = 453
// module chunks = 1